<script lang="ts">
    import type {DomainDiff, UpdatedEntity} from "$lib/models/MasterdataDiff";
    import type {Location} from "$lib/models/Location";

    const {locationDiff, updatedLocations}: {
        locationDiff: DomainDiff<Location> | undefined,
        updatedLocations: UpdatedEntity<Location>[]
    } = $props()
</script>

<ul class="ml-1">
  <li>
    <span class="font-bold">New ({locationDiff?.added.length ?? 0}):</span>
    <br>
    {#each locationDiff?.added ?? [] as added (added.id)}
      <div class="pl-1">
        <i>Name:</i> {added.name}
      </div>
    {/each}
  </li>
  <li>
    <span class="font-bold">Updated ({locationDiff?.updated.length ?? 0}):</span>
    <br>
    {#each updatedLocations ?? [] as location (location.entity.id)}
      <div class="pl-1">
        <i>Name:</i> {location.entity.name}
      </div>
      <ul style="list-style-type: none; padding-left: 1rem;">
        {#each Object.entries(location.changedFields) as [field, value] (field)}
          <li>
            <i>{field}:</i> {value.oldValue} &rarr; {value.newValue}
          </li>
        {/each}
      </ul>
    {/each}
  </li>
  <li>
    <span class="font-bold">Removed ({locationDiff?.removed.length ?? 0}):</span>
    <br>
    {#each locationDiff?.removed ?? [] as removed (removed.id)}
      <div class="pl-1">
        <i>Name:</i> {removed.name}
      </div>
    {/each}
  </li>
</ul>